"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const Client_1 = __importDefault(require("../Client"));
const Company_1 = __importDefault(require("../Company"));
const CompanyLogo_1 = __importDefault(require("../CompanyLogo"));
const Header = ({ children, entity }) => (react_2.default.createElement(react_1.Stack, { divider: react_2.default.createElement(react_1.Divider, null), spacing: "space-16" },
    entity.logoUrl ? (react_2.default.createElement(react_1.SimpleGrid, { columns: 2, spacing: "space-20" },
        react_2.default.createElement(react_1.Flex, { alignItems: "center" },
            react_2.default.createElement(CompanyLogo_1.default, { src: entity.logoUrl })),
        react_2.default.createElement(react_1.Stack, { spacing: "space-8", textAlign: "right" }, children))) : (react_2.default.createElement(react_1.Stack, { spacing: "space-8", textAlign: "left" }, children)),
    react_2.default.createElement(react_1.SimpleGrid, { columns: 2, spacing: "space-20" },
        react_2.default.createElement(Company_1.default, { company: entity.company, settings: entity.settings }),
        entity.client ? (react_2.default.createElement(react_1.Box, { textAlign: "right" },
            react_2.default.createElement(Client_1.default, { client: entity.client }))) : null)));
exports.default = Header;
